const closeAllSubmenu = () => {
  [].forEach.call(document.querySelectorAll('.Header__nav-item'), (menu) => {
    if (menu.classList.contains('is-open')) {
      menu.classList.remove('is-open');
    }
  });
};

const openSubmenu = (e) => {
  closeAllSubmenu();

  const target = e.currentTarget;

  if (!target.classList.contains('is-open')) {
    target.classList.add('is-open');
  } else {
    target.classList.remove('is-open');
  }
};

const submenuToggle = () => {
  [].forEach.call(document.querySelectorAll('.Header__nav-item'), (menu) => {
    const submenu = menu.querySelector('ul');

    if (submenu) {
      menu.addEventListener('click', openSubmenu);
    }
  });
};

export default submenuToggle;
